import { FunctionComponent } from "react";
import { UseFormRegister } from "react-hook-form";

interface IRadioGroupWithRegisterProps {
    options: { id: string; label: string }[];
    name: string;
    register: UseFormRegister<any>
    containerStyles?: string;
    answersStyles?: string;
    labelStyles?: string;
    labelTextStyles?: string;
    questionStyles?: string;
    question?: string;
    error?: string;
  }

const RadioGroupWithRegister: FunctionComponent<IRadioGroupWithRegisterProps> = ({ 
    options, 
    name, 
    register,
    containerStyles, 
    answersStyles,
    labelStyles,
    labelTextStyles, 
    questionStyles,
    question, 
    error
}) => (
    <div className={`space-y-2 ${containerStyles}`}>
        {question ? <p className={`font-semibold ${questionStyles}`}>{question}</p> : <></>}
        <div className={`flex flex-wrap lg:flex-nowrap ${answersStyles}`}>
        {options.map((option) => (
          <label key={option.id} className={`flex items-center space-x-3 cursor-pointer mr-8 mb-3 lg:mb-0 ${labelStyles}`}>
            <input
              type="radio"
              {...register(name)}
              value={option.id}
              className="form-radio h-4 w-4 text-blue-600 transition duration-150 ease-in-out focus:ring focus:ring-offset-1 focus:ring-blue-500"
            />
            <span className={`text-gray-800 ${labelTextStyles}`}>{option.label}</span>
          </label>
        ))}
        {error && (<p className="text-red-500 text-sm mt-1">{error}</p>)}
        </div>
      </div>
    )

export default RadioGroupWithRegister;